var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "yxtbiz-comment__images",
        this.disabled ? "yxtbiz-comment__images--disabled" : "",
      ],
    },
    [
      _c(
        "yxtf-popover",
        {
          attrs: {
            placement: "bottom-start",
            width: "256",
            trigger: "click",
            "popper-class": "yxtbiz-comment__images-popper",
            disabled: _vm.disabled,
          },
          model: {
            value: _vm.popVisible,
            callback: function ($$v) {
              _vm.popVisible = $$v
            },
            expression: "popVisible",
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "yxtbiz-comment__img-icon hover-primary-6",
              class: { "color-primary-6 is-active": _vm.popVisible },
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c("yxt-svg", {
                class:
                  _vm.projName === "bbs" && _vm.files.length > 0
                    ? "lengthColor"
                    : "",
                attrs: {
                  width: "14px",
                  height: "14px",
                  "icon-class": "comment_img",
                  "remote-url": _vm.mediaPath,
                },
              }),
              _c(
                "span",
                {
                  staticClass: "ml8 color-gray-9",
                  class:
                    _vm.projName === "bbs" && _vm.files.length > 0
                      ? "lengthColor"
                      : "",
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_comment_add")))]
              ),
              _vm.projName === "bbs" && _vm.files.length > 0
                ? _c("span", { staticClass: "color-primary-5" }, [
                    _vm._v("(" + _vm._s(_vm.files.length) + ") "),
                  ])
                : _vm._e(),
              _vm.projName === "bbs" && _vm.files.length > 0
                ? _c("yxtf-svg", {
                    staticClass: "ml5 a-link-hover",
                    attrs: {
                      width: "16px",
                      height: "16px",
                      "icon-class": "delete",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleDelete.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "yxtbiz-comment__image-list" }, [
            _c("h4", { staticClass: "yxtbiz-comment__pop-title" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("pc_biz_comment_upload")))]),
            ]),
            _c("p", { staticClass: "mb8 yxtbiz-comment__pop-num" }, [
              _vm._v(
                _vm._s(_vm.$t("pc_biz_comment_upload_count", [_vm.count])) + " "
              ),
              _c("span", { staticClass: "color-primary-6" }, [
                _vm._v(_vm._s(_vm.rest)),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("pc_biz_comment_unit"))),
            ]),
            _c(
              "div",
              { staticClass: "overflow-hidden" },
              [
                _vm._l(_vm.files, function (img) {
                  return _c(
                    "div",
                    {
                      key: img.uuid,
                      staticClass: "yxtbiz-comment__image float-left",
                    },
                    [
                      _c("yxtf-image", {
                        class: _vm.projName === "bbs" ? "bbs_image_Class" : "",
                        attrs: { src: img.url, fit: _vm.fitClass },
                      }),
                      _c(
                        "i",
                        {
                          staticClass: "yxtbiz-comment__close",
                          on: {
                            click: function ($event) {
                              return _vm.removeImage(img.url, img.uuid)
                            },
                          },
                        },
                        [
                          _c("yxt-svg", {
                            attrs: {
                              width: "8px",
                              height: "8px",
                              "icon-class": "comment_close",
                              "remote-url": _vm.mediaPath,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeImage(img.url, img.uuid)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _c(
                  "yxtbiz-upload",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.rest > 0,
                        expression: "rest > 0",
                      },
                    ],
                    ref: "bizUpload",
                    staticClass: "yxtbiz-comment__image float-left",
                    attrs: {
                      "config-key": _vm.options.configKey,
                      "module-name": _vm.options.moduleName,
                      "function-name": _vm.options.functionName,
                      appCode: _vm.options.appCode,
                      "before-upload": _vm.beforeUpload,
                      "on-progress": _vm.onProgress,
                      "on-uploaded": _vm.onUploaded,
                      "on-error": _vm.onError,
                      "files-added": _vm.filesAdded,
                      "file-filtered": _vm.oversize,
                      version: "v2",
                      "scene-code": "bbs",
                      multipe: "",
                      "max-size": _vm.options.size,
                    },
                  },
                  [
                    _c("div", { staticClass: "border-primary-6" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "yxtbiz-comment__upload-icon hover-primary-6",
                        },
                        [
                          _c("yxt-svg", {
                            attrs: {
                              width: "16px",
                              height: "16px",
                              "icon-class": "comment_pls",
                              "remote-url": _vm.mediaPath,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeImage(
                                  _vm.img.url,
                                  _vm.img.uuid
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }